export const CommonSystemToponomyCrumbs = [
  {
    name: 'Home',
    path: '/',
  },
  {
    name: 'Sistema',
    path: '/sistema',
  },
];
